import { useTranslation } from 'react-i18next';

type Point = { subKey: string; bodyKey: string; img: string; imgAltKey?: string };

const points: Point[] = [
  { subKey: 'association.role.sub1', bodyKey: 'association.role.para1', img: '/images/generated/association-hero-2026.jpg' },
  { subKey: 'association.role.sub2', bodyKey: 'association.role.para2', img: '/images/generated/association-cert-2026.jpg', imgAltKey: 'association.role.imgAlt' },
  { subKey: 'association.role.sub3', bodyKey: 'association.role.para3', img: '/images/generated/corp-home-training-01.jpg' },
];

export default function AssociationRole() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 sm:px-8 md:px-12 lg:px-16">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <p className="text-accent-600 text-[13px] tracking-[0.22em] mb-5 font-label">
            OUR ROLE
          </p>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 tracking-[0.06em] mb-3">
            {t('association.role.title')}
          </h2>
          {String(t('association.role.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] md:text-base tracking-[0.12em] mb-5">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        {/* Alternating illustrated points */}
        <div className="space-y-16 md:space-y-24">
          {points.map((point, idx) => {
            const reverse = idx % 2 === 1;
            return (
              <div key={point.subKey} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center">
                <div className={`lg:col-span-6 ${reverse ? 'lg:order-2' : 'lg:order-1'}`}>
                  <div className="relative">
                    <div className="absolute -inset-2 border border-accent-500/20 pointer-events-none hidden md:block"></div>
                    <img
                      src={point.img}
                      alt={point.imgAltKey ? t(point.imgAltKey) : t(point.subKey)}
                      className="relative w-full aspect-[4/3] object-cover object-center"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div className={`lg:col-span-6 ${reverse ? 'lg:order-1' : 'lg:order-2'}`}>
                  <div className="flex items-center gap-3 mb-4">
                    <span className="w-8 h-px bg-accent-500/60"></span>
                    <span className="section-title-en text-accent-500/70 text-[13px] tracking-[0.16em]">0{idx + 1}</span>
                  </div>
                  <h3 className="font-heading text-[21px] md:text-[25px] text-foreground-900 tracking-[0.05em] leading-[1.6] mb-5">
                    {t(point.subKey)}
                  </h3>
                  {String(t(point.bodyKey)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] md:text-[17px] text-foreground-600 tracking-[0.03em] leading-[2.05]">{__s}</p>))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
